import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { imageLoader } from "../../../../../utils/imageLoader";
import { openModal } from "../../../../../redux/actions/modalActions";
import findPdfForLot from "../../../../../utils/pdfLotFinder";

const LotsDetails = ({ singleLot, marginTop = "70px" }) => {
  const dispatch = useDispatch();
  const isDisplayed = useSelector(
    (state) => state.displayHonorairesReducer.isDisplayed,
  );
  const [showAllInfo, setShowAllInfo] = useState(false);
  const filteredPdfs = findPdfForLot(singleLot);
  // Handle document/image click

  const handleDocumentClick = (e) => {
    e.stopPropagation();

    let imageUrl = null;
    let isPDF = false;
    let title = "";

    if (filteredPdfs?.document) {
      imageUrl = imageLoader(filteredPdfs?.document[0]?.url);
      isPDF = true;
      title = `${singleLot.reference} - Document PDF`;
    } else if (singleLot?.images[0]?.image[0]?.url) {
      imageUrl = imageLoader(singleLot.images[0]?.image[0]?.url);
      title = `${singleLot.reference} - Image du lot`;
    }

    if (imageUrl) {
      const content = isPDF ? (
        <iframe
          src={imageUrl}
          style={{
            width: "80vw",
            height: "100%",
            border: "none",
            borderRadius: "8px",
          }}
          title="PDF Viewer"
        />
      ) : (
        <img
          src={imageUrl}
          alt={`Image du lot ${singleLot.reference}`}
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "8px",
          }}
        />
      );

      dispatch(openModal({ title, content }));
    }
  };

  const toggleShowAllInfo = () => {
    setShowAllInfo(!showAllInfo);
  };

  return (
    <section id="lots" style={{ marginTop: marginTop }}>
      <p className="semibold fs16 pink mb-10">Lots</p>
      <div className="d-flex gap50 bg-white radius5 px-20 py-20 ">
        <div className="w50 d-flex justify-content-center align-items-center ">
          <div
            className="pdf-container w100"
            onClick={handleDocumentClick}
            style={{ cursor: "pointer" }}
          >
            {filteredPdfs?.document ? (
              <iframe
                src={imageLoader(filteredPdfs?.document[0]?.url)}
                className="w100 radius5"
                style={{
                  height: "500px",
                  border: "none",
                  pointerEvents: "none",
                }}
                title="PDF Preview"
              />
            ) : singleLot?.images[0]?.image[0]?.url ? (
              <img
                src={imageLoader(singleLot.images[0]?.image[0]?.url)}
                title="Image Viewer"
                className="w100 radius5"
                style={{ height: "auto", border: "none" }}
                alt={`Image du lot ${singleLot.reference}`}
              />
            ) : (
              <img
                src="./assets/imgNotFound.webp"
                title="Not Found"
                className="w100 radius5"
                style={{ height: "auto", border: "none" }}
                alt="Image non trouvée"
              />
            )}
          </div>
        </div>

        <div className="w100">
          <div className="d-flex gap20 mb-20">
            <div className="d-flex flex-column gap20 w70 ">
              <div className="d-flex gap70 ">
                <div className="radius5 position-relative  text-center">
                  <img src="./assets/progress.png" alt="appart" />
                  {isDisplayed ? (
                    <span className="progression fs21 semibold text-dark-grey">
                      {singleLot.commission
                        ? singleLot?.commission?.match(/\d+(?:\.\d+)?/) + "%"
                        : "NC"}
                    </span>
                  ) : (
                    <span className="progression-hidden fs21 semibold text-dark-grey">
                      ***
                    </span>
                  )}
                  <p className="fs17 regular text-dark-grey">Honoraires</p>
                </div>
                <div className="d-flex flex-column justify-content-center">
                  <span className="fs16 regular text-dark-grey">
                    Dont immobilier
                  </span>
                  <span className="fs21 semibold text-dark-grey">
                    {Intl.NumberFormat("fr-FR").format(singleLot.price_total)}€
                  </span>
                  <span className="fs11 regular text-dark-grey">
                    TVA {singleLot.price_vat_rate} %
                  </span>
                </div>
              </div>
              <div className="d-flex gap10 flex-wrap">
                {singleLot.project_types?.map((badge) => (
                  <span
                    key={badge.documentId}
                    className="fs11 bg-green radius5 py-1 px-2 text-white"
                    title={badge.label}
                  >
                    {badge.label}
                  </span>
                ))}
              </div>
            </div>
            <div className="vertical-line"></div>
            <div className="grid-template ">
              <div className="text-center">
                <p className="blueGreen semibold fs14">Prix/m2</p>
                <span className="blueGreen semibold fs16">
                  {singleLot.price_m2?.toFixed(0) || 0} €
                </span>
              </div>
              <div className="text-center">
                <p className="blueGreen semibold fs14">Loyer/mois</p>
                <span className="blueGreen semibold fs16">
                  {singleLot.rent}€
                </span>
              </div>
              <div className="text-center">
                <p className="blueGreen semibold fs14">Rentabilité</p>
                <span className="blueGreen semibold fs16">
                  {singleLot.rent_profitability
                    ? (parseFloat(singleLot.rent_profitability) * 100)?.toFixed(
                        2,
                      ) + "%"
                    : "NC"}
                </span>
              </div>
            </div>
          </div>
          <div className="separator mb-43"></div>

          {singleLot.description ? (
            <>
              <div className="w100">
                <p className="progDescriptionTitle mb-20">Description</p>
                <div className="bg-light-grey radius5 p-20">
                  <p className="darkGrey regular fs14 line-height-1-5">
                    {singleLot.description}
                  </p>
                </div>
              </div>
            </>
          ) : (
            <div className="w100">
              <p className="progDescriptionTitle mb-20">Description</p>
              <div className="bg-light-grey radius5 p-20">
                <p className="darkGrey regular fs14 line-height-1-5">
                  Non Précisée
                </p>
              </div>
            </div>
          )}

          {/* Always show the separator and general info, but conditionally hide specific fields */}
          <div className="separator mb-43 mt-43"></div>

          <div className="d-flex justify-content-between w100 gap70">
            <div className="flex-1">
              <p className="progDescriptionTitle mb-43">Général</p>
              <div className="d-flex flex-column gap12">
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Référence</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.reference}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Type de bien</span>
                  <span className="darkGrey semibold fs14 text-capitalize">
                    {singleLot.type === "apartment" ? "Appartement" : "Maison"}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Typologie</span>
                  <span className="darkGrey semibold fs14 text-capitalize">
                    {singleLot.typology}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Étage</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.floor == null
                      ? "NC"
                      : singleLot.floor == 0
                        ? "RDC"
                        : singleLot.floor == 1
                          ? "1er"
                          : singleLot.floor + "ème"}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Exposition</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot?.geo_orientations?.length > 0
                      ? singleLot?.geo_orientations
                          .map((orientation) => orientation.orientation)
                          .join(", ")
                      : "N/C"}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Score global</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.global_score || "N/C"}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Exclusivité</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.is_exclusive ? "Oui" : "Non"}
                  </span>
                </div>

                {/* Only show these fields when showAllInfo is true */}
                {showAllInfo && (
                  <>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Usage</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.usage || "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Label</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.label || "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Annexe</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.annexe || "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">
                        Disponibilité
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.availability || "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Neuf</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.is_new ? "Oui" : "Non"}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="flex-1">
              <p className="progDescriptionTitle mb-43">Surfaces Intérieures</p>
              <div className="d-flex flex-column gap12">
                <div className="d-flex justify-content-between gap56">
                  <span className="darkGrey medium fs12">
                    Surface habitable
                  </span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.surface ? `${singleLot.surface} m²` : "N/C"}
                  </span>
                </div>
                <div className="d-flex justify-content-between gap56">
                  <span className="darkGrey medium fs12">Surface pondérée</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.weighted_surface
                      ? `${singleLot.weighted_surface} m²`
                      : "N/C"}
                  </span>
                </div>
              </div>
            </div>

            {/* Only show the whole parking section when showAllInfo is true */}

            <div className="flex-1">
              <p className="progDescriptionTitle mb-43">Surface Extérieure</p>
              <div className="d-flex flex-column gap12">
                <div className="d-flex justify-content-between gap56">
                  <span className="darkGrey medium fs12">
                    Surface extérieure totale
                  </span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.surface_exterieur
                      ? `${singleLot.surface_exterieur} m²`
                      : "N/C"}
                  </span>
                </div>
                {/* Only show these surface fields when showAllInfo is true */}
                <>
                  <div className="d-flex justify-content-between gap56">
                    <span className="darkGrey medium fs12">Surface jardin</span>
                    <span className="darkGrey semibold fs14">
                      {singleLot.garden_surface
                        ? `${singleLot.garden_surface} m²`
                        : "N/C"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between gap56">
                    <span className="darkGrey medium fs12">
                      Surface terrasse
                    </span>
                    <span className="darkGrey semibold fs14">
                      {singleLot.terrace_surface
                        ? `${singleLot.terrace_surface} m²`
                        : "N/C"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between gap56">
                    <span className="darkGrey medium fs12">Surface loggia</span>
                    <span className="darkGrey semibold fs14">
                      {singleLot.loggia_surface
                        ? `${singleLot.loggia_surface} m²`
                        : "N/C"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between gap56">
                    <span className="darkGrey medium fs12">Surface balcon</span>
                    <span className="darkGrey semibold fs14">
                      {singleLot.balcon_surface
                        ? `${singleLot.balcon_surface} m²`
                        : "N/C"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between gap56">
                    <span className="darkGrey medium fs12">Surface cave</span>
                    <span className="darkGrey semibold fs14">
                      {singleLot.cellar_surface
                        ? `${singleLot.cellar_surface} m²`
                        : "N/C"}
                    </span>
                  </div>
                  {showAllInfo && (
                    <div className="d-flex justify-content-between gap56">
                      <span className="darkGrey medium fs12">
                        Autres surfaces
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.other_surface
                          ? `${singleLot.other_surface} m²`
                          : "N/C"}
                      </span>
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>

          {/* Only show the financiers details section when showAllInfo is true */}
          {showAllInfo && (
            <>
              <div className="separator mb-43 mt-43"></div>
              <div className="d-flex justify-content-between w100 gap70">
                <div className="flex-1">
                  <p className="progDescriptionTitle mb-43">
                    Détails financiers
                  </p>
                  <div className="d-flex flex-column gap12">
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Prix HT</span>
                      <span className="darkGrey semibold fs14">
                        {Intl.NumberFormat("fr-FR").format(
                          singleLot.price_excl_vat,
                        )}
                        €
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Prix TTC</span>
                      <span className="darkGrey semibold fs14">
                        {Intl.NumberFormat("fr-FR").format(
                          singleLot.price_incl_tax,
                        )}
                        €
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Prix total</span>
                      <span className="darkGrey semibold fs14">
                        {Intl.NumberFormat("fr-FR").format(
                          singleLot.price_total,
                        )}
                        €
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Prix au m²</span>
                      <span className="darkGrey semibold fs14">
                        {Intl.NumberFormat("fr-FR").format(singleLot.price_m2)}€
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Taux TVA</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.price_vat_rate}%
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">
                        Commission (%)
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.commision_value
                          ? `${singleLot.commision_value}%`
                          : "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">
                        Loyer mensuel
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.rent ? `${singleLot.rent}€` : "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Rentabilité</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.rent_profitability
                          ? `${
                              (singleLot.rent_profitability * 100)?.toFixed(
                                2,
                              ) || 0
                            }%`
                          : "N/C"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex-1">
                  <p className="progDescriptionTitle mb-43">Parking</p>
                  <div className="d-flex flex-column gap12">
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">
                        Nombre de places
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.parking_count || "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Prix HT</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.parking_price_excl_vat
                          ? `${Intl.NumberFormat("fr-FR").format(
                              singleLot.parking_price_excl_vat,
                            )}€`
                          : "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">Prix TTC</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.parking_price_incl_tax
                          ? `${Intl.NumberFormat("fr-FR").format(
                              singleLot.parking_price_incl_tax,
                            )}€`
                          : "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">TVA parking</span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.parking_price_vat_rate
                          ? `${singleLot.parking_price_vat_rate}%`
                          : "N/C"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex-1">
                  <p className="progDescriptionTitle mb-43">
                    Travaux & Rénovation
                  </p>
                  <div className="d-flex flex-column gap12">
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">
                        Prix rénovation HT
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.renovation_price_excl_vat
                          ? `${Intl.NumberFormat("fr-FR").format(
                              singleLot.renovation_price_excl_vat,
                            )}€`
                          : "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">
                        Prix rénovation TTC
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.renovation_price_incl_tax
                          ? `${Intl.NumberFormat("fr-FR").format(
                              singleLot.renovation_price_incl_tax,
                            )}€`
                          : "N/C"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="darkGrey medium fs12">
                        TVA rénovation
                      </span>
                      <span className="darkGrey semibold fs14">
                        {singleLot.renovation_price_vat_rate
                          ? `${singleLot.renovation_price_vat_rate}%`
                          : "N/C"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {/* Toggle arrow */}
          <div className="d-flex justify-content-center mt-20 mb-20">
            <button
              onClick={toggleShowAllInfo}
              className="bg-transparent border-0 cursor-pointer d-flex align-items-center"
              aria-label={
                showAllInfo
                  ? "Masquer les détails"
                  : "Afficher tous les détails"
              }
            >
              <span className="mr-10 fs14 semibold darkGrey">
                {showAllInfo
                  ? "Masquer les détails"
                  : "Afficher tous les détails"}
              </span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transform: showAllInfo ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                <path
                  d="M8 12L2 6L3.4 4.6L8 9.2L12.6 4.6L14 6L8 12Z"
                  fill="#666666"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LotsDetails;
